import { useMemo } from 'react';
import { safeParseInt } from "shared/util"
import { DashBoardValue } from 'features/dashBoard/hooks';
import { DashBoardItemOption } from 'features/dashBoard/types';
import { getAxisDef, getValueDef, GraphOptions } from '../../common'

import {
  Sort as SortIcon
 } from '@mui/icons-material'

 import { TargetListResult } from "interface/search/targetList"

 export const MultiPieGraphOptions: GraphOptions[][] = [
  [
    {
      id: 'axis2',
      type: 'axis',
      label: 'グラフ単位',
      suffix: 'ごと'
    },
    {
      id: 'row',
      type: 'numeric',
      defaultValue: 1,
      minValue: 1,
      maxValue: 30,
      label: '縦'
    }
  ],
  [
    {
      id: 'axis',
      type: 'axis',
      label: '軸',
      suffix: 'ごとの'
    },
    {
      id: 'value',
      type: 'value',
      label: '値'
    },
    {
      id: 'sort',
      type: 'check',
      label: '並び替え',
      default: 'false',
      toolBtn: <SortIcon fontSize="small"/>
    }
  ]
]

type useMultiPieGraphOptionProps<T> = {
  options?: DashBoardItemOption[]
  dashBoard: DashBoardValue<T>
  targetList?: TargetListResult
}
export const useMultiPieGraphOption = <T,>({
  options,
  dashBoard: {
    configure,
		globalAxisKey
  },
  targetList
}: useMultiPieGraphOptionProps<T>) => useMemo(
  () => ({
    configure, targetList,
    axisDef: getAxisDef(configure, options, 'axis', globalAxisKey, targetList),
    axis2Def: getAxisDef(configure, options, 'axis2', globalAxisKey, targetList),
    valueDef: getValueDef(configure, options, 'value', targetList),
    sort: options?.find((opt) => opt.id === 'sort')?.value === 'true',
    row: safeParseInt(options?.find((opt) => opt.id === 'row')?.value ?? null) ?? 1
}),
  [configure, options, globalAxisKey, targetList]
)
